var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"appear":"","name":"error-box-transition"},on:{"before-enter":_vm.beforeEnter,"enter":_vm.enter,"after-enter":_vm.afterEnter,"leave":_vm.leave}},[_c('div',[_c('div',{staticClass:"error-box-parent"},[_c('div',{staticClass:"error-box"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }